import axios from 'axios';

const API_URL = process.env.VUE_APP_HOST + '/api/group';


let access_token = "";

let auth = localStorage.getItem('session-authorization');

if (!auth) {
  access_token = process.env.VUE_APP_TOKEN;
  if (!access_token) {
    console.log(window.location.hash)
    var queries = window.location.hash.split("access_token=")
    if (queries.length > 1) {
      access_token = queries[1].split("&")[0]
      if (access_token) {
        let auth = "{\"access_token\":\"" + access_token + "\",\"token_type\":\"\Bearer\",\"expires_in\":\"3600\"}";
        localStorage.setItem('session-authorization', auth);
      }
    }
  }
}
else {
  access_token = JSON.parse(auth).access_token;
}

let headers = {
  headers: {
    'Authorization': `Bearer ${access_token}`,
    'Content-Type': 'application/json'
  }
};


export const groupApi = {
    getAllGroups: async () => {
        const response = await axios.get(API_URL, headers);
        return response.data;
    },

    createGroup: async (group) => {
        const groupWithId = { ...group, id: group.id || '' };
        const response = await axios.post(API_URL, groupWithId, headers);
        return response.data;
    },

    updateGroup: async (id, group) => {
        const groupWithId = { ...group, id };
        const response = await axios.put(`${API_URL}/${id}`, groupWithId, headers);
        return response.data;
    },

    deleteGroup: async (id) => {
        const response = await axios.delete(`${API_URL}/${id}`, headers);
        return response.data;
    }
};

